import React, { useState, useEffect } from "react";
import {
  Button,
  Input,
  Row,
  Col,
  InputGroup,
  ButtonGroup,
  Label,
  FormGroup,
} from "reactstrap";
import { Triangle } from "react-loader-spinner";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import OrganizationService from "../../../Services/QRCodeServices/OrganizationManagement/OrganizationService";

import DeleteModal from "../../../Components/Common/DeleteModal";
import UpdateOrganization from "../Component/UpdateOrganization";
import CreateOrgDbModal from "../Component/CreateOrgDbModal";
import "./SwitchModal.css";

const OrganizationManagement = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [createDbModalOpen, setCreateDbModalOpen] = useState(false)
  const [selectedOrgName, SetSelectedOrgName] = useState('')
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    totalData: 0,
  });

  const statusColor = { Paid: "bg-success", Unpaid: "bg-danger" };
  const statusColor1 = { true: "bg-success", false: "bg-danger" };

  // Fetch organizations with pagination
  const fetchOrganizations = async (pageNumber = 1, pageSize = 10) => {
    setLoading(true);
    try {
      const response = await OrganizationService.getList({
        pageNumber,
        pageSize,
        searchQuery,
        statusFilter,
      });

      if (response && response.data) {
        setData(response.data);
        setPagination({
          currentPage: response.currentPage,
          pageSize: response.pageSize,
          totalPages: response.totalPages,
          totalData: response.totalData,
        });
      } else {
        console.error("Unexpected response structure:", response);
        setData([]);
      }
    } catch (error) {
      toast.error("Error fetching organizations");
      console.error("Error fetching organizations:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganizations();
  }, [searchQuery, statusFilter]);

  const toggleCreateDbModal = ()=>{
  
      setCreateDbModalOpen(prev => !prev)
    
  }

  const handleCreateDbModal = ()=>{

     if(selectedOrganizations.length == 0){
      toast.error("Please Select an organization first")
      return 
    }else if(selectedOrganizations.length >=2){
      toast.error("Please Select Only one Organization") 
      return 
    }

    const FilteredSelectedOrg = data.filter((e)=> selectedOrganizations[0] === e.id )


     if(FilteredSelectedOrg[0].hasSeperateDatabase){
      toast.error("This Organization already has a Seperate Database") 
      return
     }


     
    
      SetSelectedOrgName(FilteredSelectedOrg[0].name)
     

      setCreateDbModalOpen(true)
    
  }

  // Handle page change
  const handlePageChange = (page) => {
    fetchOrganizations(page, pagination.pageSize);
  };

  // Handle rows per page change
  const handlePerRowsChange = async (newPageSize, page) => {
    fetchOrganizations(page, newPageSize);
  };

  // Checkbox selection handler
  const handleCheckboxChange = (id) => {
    setSelectedOrganizations((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((orgId) => orgId !== id)
        : [...prevSelected, id]
    );
  };

  // console.log(selectedOrganizations)

  // Set organizations as paid
  const handlePaid = async () => {
    if (selectedOrganizations.length === 0) {
      toast.error("Please select at least one organization.");
      return;
    }

    try {
      await OrganizationService.setAsPaid({
        orgIds: selectedOrganizations.map((org) =>
          typeof org === "number" ? org : org.id
        ),
      });
      toast.success("Selected organizations have been set as paid.");
      fetchOrganizations(pagination.currentPage, pagination.pageSize);
      setSelectedOrganizations([]);
    } catch (error) {
      console.error("Set as Paid Error:", error);
      toast.error("Failed to set the selected organizations as paid.");
    }
  };

  const handleOMS = async () => {
    if (selectedOrganizations.length === 0) {
      toast.error("Please select at least one organization.");
      return;
    }

    try {
      await OrganizationService.setAsHasOMS({
        orgIds: selectedOrganizations.map((org) =>
          typeof org === "number" ? org : org.id
        ),
      });
      toast.success(
        "Selected organizations have been set as has organization management system."
      );
      fetchOrganizations(pagination.currentPage, pagination.pageSize);
      setSelectedOrganizations([]);
    } catch (error) {
      console.error("Set as OMS Error:", error);
      toast.error("Failed to set the selected organizations as having OMS.");
    }
  };

  const handleSalesScreen = async () => {
    if (selectedOrganizations.length === 0) {
      toast.error("Please select at least one organization");
      return;
    }
    try {
      await OrganizationService.setHasSalesScreen({
        orgIds: selectedOrganizations.map((org) =>
          typeof org === "number" ? org : org.id
        ),
      });
      toast.success(
        "Selected organizations have been set as having sales screen."
      ),
        fetchOrganizations(pagination.currentPage, pagination.pageSize);
      setSelectedOrganizations([]);
    } catch (error) {
      console.error("Set Has Sales Screen Error:", error);
      toast.error(
        "Failed to set the selected organizations as having sales screen."
      );
    }
  };

  // Delete organization
  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await OrganizationService.delete(selectedDeleteItem.id);
        toast.success("Organization deleted successfully");
        fetchOrganizations(pagination.currentPage, pagination.pageSize);
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        setDeleteModal(false);
        setSelectedDeleteItem(null);
      }
    }
  };

  const columns = [
    {
      selector: (row) => (
        <Label check>
          <Input
            type="checkbox"
            checked={selectedOrganizations.includes(row.id)}
            onChange={() => handleCheckboxChange(row.id)}
          />
        </Label>
      ),
      sortable: false,
      width: "50px",
    },
    {
      name: "S.N",
      selector: (row, index) =>
        (pagination.currentPage - 1) * pagination.pageSize + index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => (
        <div className="d-flex gap-2 align-items-center">
          {row?.displayImageLogo && (
            <img
              src={row?.displayImageLogo?.getCDNUrl()}
              alt={row?.title || "Logo"}
              style={{ width: "50px", height: "50px", objectFit: "cover" }}
            />
          )}
          <Link to={`/organization/detail/${row?.id}`}>{row?.name}</Link>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Org Code",
      selector: (row) => row?.orgCode || "N/A",
      sortable: true,
    },
    {
      name: "Address",
      selector: (row) => `${row?.address1}` || "N/A",
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => `${row?.email}` || "N/A",
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => (row?.isPaid ? "Paid" : "Unpaid"),
      cell: (row) => (
        <span
          className={`badge ${statusColor[row?.isPaid ? "Paid" : "Unpaid"]}`}
        >
          {row?.isPaid ? "Paid" : "Unpaid"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Has OMS",
      selector: (row) => (row?.hasOMS ? "true" : "false"),
      cell: (row) => (
        <span
          className={`badge ${statusColor1[row?.hasOMS ? "true" : "false"]}`}
        >
          {row?.hasOMS ? "true" : "false"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Has Sales",
      selector: (row) => (row?.hasSalesScreen ? "true" : "false"),
      cell: (row) => (
        <span
          className={`badge ${
            statusColor1[row?.hasSalesScreen ? "true" : "false"]
          }`}
        >
          {row?.hasSalesScreen ? "true" : "false"}
        </span>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <ButtonGroup className="gap-3">
          <Button
            color="warning"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            style={{ width: "30px", height: "30px" }}
            onClick={() => navigate(`/update-profile/${row.id}`)}
          >
            <i className="bx bx-edit"></i>
          </Button>
          <Button
            color="danger"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            style={{ width: "30px", height: "30px" }}
            onClick={() => {
              setSelectedDeleteItem(row);
              setDeleteModal(true);
            }}
          >
            <i className="bx bx-trash"></i>
          </Button>
        </ButtonGroup>
      ),
      center: true,
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          title="Organization Management List"
          pageTitle="Organization Management"
        />
      </div>
      <Row className="mb-3">
        <Col md={6} >
          <Row >
            <Col md={8} xs={6} className="px-xs-1">
              <InputGroup>
                <Input
                  placeholder="Search by organization name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </InputGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <select
                  className="form-select"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="all">All</option>
                  <option value="paid">Paid</option>
                  <option value="unpaid">Unpaid</option>
                </select>
              </FormGroup>
            </Col>
          </Row>
        </Col>

        <Col md={6}>
          <Row>
            <Col md={3} className="align-items-end text-end ">
              <Button color="success" className="org-btn-font-size" onClick={handlePaid}>
                Set as has Paid
              </Button>
            </Col>
            <Col  md={3} className="align-items-end text-end  ">
              <Button color="secondary" className="org-btn-font-size" onClick={handleOMS}>
                Set as has OMS
              </Button>
            </Col>
            <Col  md={3} className="align-items-end text-end org-btn-font-size">
              <Button color="secondary" onClick={handleSalesScreen}>
                Set as has POS
              </Button>
            </Col>

            <Col  md={3} className="align-items-end text-end org-btn-font-size">
              <Button color="secondary" onClick={handleCreateDbModal}>Create Org Database</Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <CustomDataTable
        responsive
        striped
        pagination
        paginationServer
        paginationTotalRows={pagination.totalData}
        paginationRowsPerPageOptions={[10, 25, 50, 100]}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        fixedHeader
        persistTableHead
        progressPending={loading}
        columns={columns}
        data={data}
        customStyles={{
          headCells: { style: { fontSize: "0.93rem", fontWeight: 610 } },
          rows: { style: { fontSize: "0.9rem" } },
        }}
        progressComponent={
          <div className="my-3 text-center">
            <Triangle
              visible={true}
              height="80"
              width="80"
              color="#5B71B9"
              ariaLabel="triangle-loading"
            />
            <h5 className="mt-1">Loading...</h5>
          </div>
        }
      />

      <UpdateOrganization
        isOpen={modalOpen}
        toggleModal={() => setModalOpen(!modalOpen)}
        onSubmit={(newOrg) => {
          fetchOrganizations(pagination.currentPage, pagination.pageSize);
        }}
        data={data}
      />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => setDeleteModal(false)}
        selectedItem={selectedDeleteItem}
      />

      <CreateOrgDbModal 
          isOpen={createDbModalOpen}
          toggleModal={toggleCreateDbModal}
          selectedOrganization = {selectedOrganizations}
          selectedOrgName={selectedOrgName}
      />
    </div>
  );
};

export default OrganizationManagement;
